@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.listThemeItemRoot {
  @include border-radius-r1;

  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px;
  cursor: pointer;
  border: none;
  background: none;

  &:hover {
    background-color: var(--surface-hover);
  }

  &,
  &:focus-visible {
    outline: none;
  }

  &.isFocused {
    &,
    &:focus-visible {
      outline: 2px solid var(--border-focus);
    }
  }

  [data-theme-logo-icon] {
    height: 32px;
    width: 32px;
    border-radius: 40px;
  }
}

.details {
  display: flex;
  flex-direction: column;
  text-align: left;

  mark {
    color: var(--text-primary);
    background-color: transparent;
  }
}

.title {
  @include typography-v2-body-sm;

  color: var(--text-default);
}

.subtitle {
  @include typography-v2-body-xs;

  color: var(--text-soft);
}

.logoWrapper {
  @include typography-v2-title-sm;

  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--icon-decorative-blue);
  height: 32px;
  width: 32px;
  border-radius: 40px;
  color: var(--text-default);
}
